import React from "react";
import { Row, Col, Card, Divider } from "antd";
import { ITripDetails } from "../../../ServiceUsers/Interfaces/ITripDetails";
import styles from "./TripCards.module.scss";
import textStyles from "../../../DashBoard/BookingSummary/BookingSummary.module.scss";
import { CreditCardDetails } from "../../../../types/PaymentTypes";
import moment from "moment";
import getCreditCardKindIcon from "../../../../helpers/getCreditCardKindIcon";
import { getGrandTotalCost } from "../../../../helpers/tripHelper";

type Props = {
  trip: ITripDetails[];
  ccInfo: CreditCardDetails;
};
function TripPaymentCard({ trip, ccInfo }: Props) {
  return (
    <Card className={styles.costCardsContainer}>
      <Row className={textStyles.normalText20} gutter={[0, 16]}>
        Payment <Col span={24} />
      </Row>

      {trip.map((leg: ITripDetails, index: number) => (
        <Row
          key={leg.bookingId}
          className={`${styles.legCostsAlign} ${textStyles.boldText14}`}
        >
          <Col span={12}>Trip {index + 1}</Col>
          <Col span={12}>${leg.tripCost?.toFixed(2)}</Col>
        </Row>
      ))}

      <Divider className={styles.solidDivider} />

      <Row
        className={`${textStyles.normalText16} ${styles.overallCostAlign}`}
        gutter={[0, 4]}
      >
        <Col span={12}>Total cost</Col>
        <Col span={12}>${getGrandTotalCost(trip).tripCostWithDiscount}</Col>
        <Col span={24} className={textStyles.normalText14}>
          You'll only be charged after each individual trip is complete.
        </Col>
      </Row>

      <Divider className={styles.dashedDivider} dashed />

      <Row gutter={[0, 4]}>
        <Col span={24} className={textStyles.normalText16}>
          Saved card
        </Col>

        <Col span={24}>
          <Row align="middle" gutter={[10, 0]}>
            <Col>{getCreditCardKindIcon(ccInfo?.kind)}</Col>
            <Col>
              <Row className={textStyles.boldText14}>**** {ccInfo?.last4}</Row>
              <Row className={textStyles.fadedNormalText14}>
                Expires {moment(ccInfo?.expiresOn).format("MM/YYYY")}
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
}

export default TripPaymentCard;
